export default {
  Spell: 'spell',
  Contest: 'contest',
};
